<template>
	<div class="content-detail-h">
		<div class="divider-line"></div>
		<div class="left">
			<div class="left-wrapper">
				<div class="inline-column left-item" v-for="(item, idx) in dataList" :key="idx" 
					@click="onClickItem(item)" :class="{'active': item.id == recId}">
					<img class="icon-block" src="~@/assets/png/node-icon.png" />
					<span class="single-line">{{item.title}}</span>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="title-wrapper">
				<div class="title inline-column-left">
					<img class="bg" src="~@/assets/png/content-title-icon.png" />
					<div class="txt" v-if="curData">
						<template v-if="curData.tag1">{{curData.tag1}}<span>·</span></template>
						<template v-if="curData.tag2">{{curData.tag2}}<span>·</span></template>
						{{curData.title}}</div>
				</div>
			</div>
			<div class="auto-height" v-if="curData">
				<div class="content calc-line" v-html="curData.content"></div>
			</div>
			<!-- <copy-right /> -->
		</div>
	</div>
</template>

<script>
	import IndexMixin from './mixins/index.js';
	import CopyRight from '@/components/copyRight';
	export default {
		name: 'ContentDetailH',
		mixins: [IndexMixin],
		components: {
			CopyRight
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.content-detail-h {
		width: 100%;
		height: 100%;
		position: relative;
		display: flex;
		flex-direction: row;
		.divider-line {
			position: absolute;
			border-right: 1px dashed rgb(49, 75, 137);
			width: calc(10px * var(--scale-rate));
			left: 0;
			top: 0;
			bottom: calc(50px * var(--scale-rate));
		}
		.left {
			width: calc(330px * var(--scale-rate));
			overflow-x: hidden;
			overflow-y: auto;
			.left-wrapper {
				width: 330px;
				transform: scale(var(--scale-rate));
				transform-origin: left top;
				margin-top: 55px;
			}
			.left-item {
				margin-left: 10px;
				margin-top: 15px;
				width: 185px;
				height: 35px;
				position: relative;
				border-bottom: 1px dashed rgb(49, 75, 137);
				padding-left: 35px;
				
				span {
					font-size: 18px;
					line-height: 35px;
					color: rgb(49, 75, 137);
					cursor: pointer;
					max-width: 100%;
				}
				.icon-block {
					position: absolute;
					left: -7px;
					bottom: -7px;
					width: 14px;
					height: 14px;
				}
				
				&.active {
					span {
						font-weight: bold;
					}
				}
			}
		}
		.right {
			flex: 1;
			position: relative;
			overflow: auto;
			.title-wrapper {
				width: 100%;
				height: calc(85px * var(--scale-rate));
				position: relative;
				margin-top: calc(10px * var(--scale-rate));
			}
			.title {
				position: absolute;
				top: 0;
				left: 0;
				width: calc(100% / var(--scale-rate));
				height: 85px;
				transform: scale(var(--scale-rate));
				transform-origin: left top;
				padding-left: 25px;
				padding-top: 3px;
				
				.txt {
					font-size: 24px;
					color: rgb(96, 96, 96);
					span {
						padding: 0 10px;
					}
				}
				.bg {
					position: absolute;
					left: 8px;
					top: 0;
					width: 78px;
					height: 85px;
				}
			}
			.auto-height {
				width: 100%;
			}
			.content {
				margin-top: calc(38px * var(--scale-rate));
				//border: 1px solid #000000;
				width: calc(100% / var(--scale-rate));
				overflow-y: auto;
				overflow-x: hidden;
				transform: scale(var(--scale-rate));
				transform-origin: left top;
			}
		}
		.right::-webkit-scrollbar {
			background-color: transparent;
		}
	}
</style>